// eslint-disable-next-line no-unused-vars
function toggleAccordion(element) {
  const orderGroup = element.getAttribute('data-order-group')
  const panel = document.getElementById('order-panel-' + orderGroup)
  // TOGGLE CLOSE
  if (element.classList.contains('active')) {
    element.classList.remove('active')
    panel.style.display = 'none'

    // TOGGLE OPEN
  } else {
    element.classList.add('active')
    panel.style.display = 'block'
    panel.style.height = 'auto'
  }
}

// Page URL
const pageURL = window.location.href

// Is Test
const isTest = (pageURL.includes('test.tnhs.cloud') || pageURL.includes('dev0.tnhs.cloud'))

function loadOrders(noOrdersBlock, accountPageMainBlock, sessionKeyURL, customerNumber) {
  // LOADING BLOCK
  const loadingBlockElement = document.createElement('div')
  loadingBlockElement.classList.add('tn-customisation-loading-block')
  loadingBlockElement.innerHTML = '<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>'
  accountPageMainBlock.append(loadingBlockElement)

  const xhttp = new XMLHttpRequest()
  xhttp.onreadystatechange = function () {
    // SHOW DATE PICKER
    if (this.readyState === 4) {
      loadingBlockElement.remove()
    }

    // ERROR
    if (this.readyState === 4 && this.status === 400) {
      // EMPTY ORDER HISTORY
      noOrdersBlock.style.display = 'block'
      noOrdersBlock.innerHTML = 'We could not find any orders on your account.'
      return noOrdersBlock
    }

    // OK
    if (this.readyState === 4 && this.status === 200) {
      // RETURNED ORDERS
      const orders = JSON.parse(this.response)

      console.log(orders)

      // EMPTY ORDER HISTORY
      if (!orders || orders.length === 0 || orders.message === 'No orders were found!') {
        noOrdersBlock.style.display = 'block'
        noOrdersBlock.innerHTML = 'We could not find any orders on your account.'
        return
      }

      // REMOVE UNEEDED ELEMENTS
      noOrdersBlock.style.display = 'none'

      // CREATE ORDER HISTORY LABELS
      const orderHistoryLabels = document.createElement('div')
      orderHistoryLabels.classList.add('tn-customisation-orders-labels')
      orderHistoryLabels.innerHTML = '<li class="grid-container tn-customisation-order-titles"><div class="tn-customisation-order-id">Order Time and Date</div><div>Order Number</div><div>Total Price</div><div></div></li>'
      accountPageMainBlock.append(orderHistoryLabels)

      // CREATE ORDER HISTORY LIST
      const orderHistoryList = document.createElement('ul')
      orderHistoryList.classList.add('tn-upcoming-event__list')
      orderHistoryList.style.display = 'block'
      accountPageMainBlock.append(orderHistoryList)

      // LOOP THROUGH ORDERS
      orders.forEach(order => {
        // ORDER HISTORY ITEM
        const orderHistoryItem = document.createElement('li')
        orderHistoryItem.classList.add('tn-upcoming-event__list-item')
        orderHistoryItem.classList.add('tn-customisation-event-list-item')

        // ORDER ACTION LIST
        const orderHistoryItemActionList = document.createElement('div')
        orderHistoryItemActionList.classList.add('tn-upcoming-event__actions-list')
        orderHistoryItemActionList.style.margin = '0px'
        orderHistoryItem.append(orderHistoryItemActionList)

        // ACTIONS - ORDERS ACCORDION BUTTON
        const orderHistoryAccordionButton = document.createElement('button')
        orderHistoryAccordionButton.classList.add('tn-customisation-orders-accordion')
        orderHistoryAccordionButton.setAttribute('data-order-group', order.id)
        orderHistoryAccordionButton.innerHTML = '<li class="grid-container tn-customisation-order-titles"><div class="tn-customisation-order-id">' + order.dateTime + '</div><div>' + order.id + '</div><div>' + order.total + '</div><div><span class="glyphicon glyphicon-chevron-down"></span></div></li>'
        orderHistoryAccordionButton.addEventListener('click', function () {
          toggleAccordion(this)
          loadOrderDetail(order, sessionKeyURL, customerNumber)
        }, false)

        // ACTIONS - ORDERS ACCORDION PANEL (SETUP)
        const orderHistoryAccordionPanel = document.createElement('ul')
        orderHistoryAccordionPanel.classList.add('tn-customisation-orders-panel')
        orderHistoryAccordionPanel.setAttribute('id', 'order-panel-' + order.id)

        // APPEND IN DISPLAY ORDER
        orderHistoryItemActionList.append(orderHistoryAccordionButton)
        orderHistoryItemActionList.append(orderHistoryAccordionPanel)

        // APPEND ITEM TO LIST
        orderHistoryList.append(orderHistoryItem)
      })
    }
  }
  const testParam = (isTest) ? 'true' : 'false';
  xhttp.open('GET', 'https://api.santafeopera.org/santa-fe/en/account-service/orders?tnewqa=' + sessionKeyURL + '&test=' + testParam + '&customerNumber=' + customerNumber, true)
  xhttp.send()
}

function loadOrderDetail(order, sessionKeyURL, customerNumber) {
  const orderPanel = document.getElementById('order-panel-' + order.id)
  orderPanel.innerHTML = null

  // LOADING BLOCK
  const loadingBlockElement = document.createElement('div')
  loadingBlockElement.classList.add('tn-customisation-loading-block')
  loadingBlockElement.innerHTML = '<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>'
  orderPanel.append(loadingBlockElement)

  // CREATE NO ORDERS BLOCK
  const noOrdersBlock = document.createElement('div')
  noOrdersBlock.classList.add('tn-empty-cart-message')
  noOrdersBlock.style.display = 'none'
  orderPanel.append(noOrdersBlock)

  const xhttp = new XMLHttpRequest()
  xhttp.onreadystatechange = function () {
    // SHOW DATE PICKER
    if (this.readyState === 4) {
      loadingBlockElement.remove()
    }

    // ERROR
    if (this.readyState === 4 && this.status === 400) {
      // EMPTY ORDER HISTORY
      noOrdersBlock.style.display = 'block'
      noOrdersBlock.innerHTML = 'We could not find any order details'
      return noOrdersBlock
    }

    // OK
    if (this.readyState === 4 && this.status === 200) {
      // RETURNED ORDERS
      const orderDetail = JSON.parse(this.response)

      console.log(orderDetail)

      // EMPTY ORDER HISTORY
      if (!orderDetail || orderDetail.length === 0 || orderDetail.message === 'No order detail was found!') {
        noOrdersBlock.style.display = 'block'
        noOrdersBlock.innerHTML = 'We could not find any order details'
        return
      }

      // REMOVE UNEEDED ELEMENTS
      noOrdersBlock.remove()

      // DISPLAY ORDER
      orderDetail.products.forEach(product => {
        const orderProductDisplay = document.createElement('div')
        orderProductDisplay.classList.add('tn-customisation-product-block')
        const orderItemsDisplay = []
        if (product.type === 'performance') {
          orderItemsDisplay.push(`
          <h3>${product.title}</h3>
          <h5>${product.date}</h5>
          <li class="grid-container">
          `)
          product.tickets.forEach(ticket => {
            orderItemsDisplay.push(`
            <div>
              <strong>Row:</strong> ${ticket.seat.row}
            </div>
            <div>
              <strong>Seat:</strong> ${ticket.seat.number}
            </div>
            <div class="tn-customisation-ticket-seat-total">
              ${ticket.seat.total}
            </div>
            `)
          })
          orderItemsDisplay.push(`
          </li>
          `)
        }
        if (product.type === 'package') {
          product.packageContents.forEach(packageItem => {
            orderItemsDisplay.push(`
            <h3>${packageItem.title}</h3>
            <h5>${packageItem.date}</h5>
            <li class="grid-container">
            `)
            packageItem.tickets.forEach(ticket => {
              orderItemsDisplay.push(`
              <div>
                <strong>Row:</strong> ${ticket.seat.row}
              </div>
              <div>
                <strong>Seat:</strong> ${ticket.seat.number}
              </div>
              <div class="tn-customisation-ticket-seat-total">
              ${ticket.seat.total}
              </div>
              `)
            })
            orderItemsDisplay.push(`
            </li>
            `)
          })
        }
        const productsObject = orderItemsDisplay.join(' ')
        orderProductDisplay.innerHTML = productsObject
        orderPanel.append(orderProductDisplay)
      })
      const orderTotalDisplay = document.createElement('div')
      orderTotalDisplay.classList.add('tn-customisation-total-block')
      orderTotalDisplay.innerHTML = `
        <h4><strong>Fees:</strong> ${orderDetail.details.fees}</h4>
        <h3><strong>Total:</strong> ${orderDetail.details.total}</h3>
      `
      orderPanel.append(orderTotalDisplay)
    }
  }

  const testParam = (isTest) ? 'true' : 'false';
  xhttp.open('GET', 'https://api.santafeopera.org/santa-fe/en/account-service/orders/' + order.id + '/order-detail?tnewqa=' + sessionKeyURL + '&test=' + testParam + '&customerNumber=' + customerNumber, true)
  xhttp.send()
}

if (pageURL.includes('account')) {
  // ACCOUNT PAGE EXCEPTIONS
  const exceptions = ['login', 'logout', 'register', 'create']
  const doesNotContain = (target, pattern) => {
    let value = 0
    pattern.forEach((word) => {
      value = value + target.includes(word)
    })
    return (value === 0)
  }

  // GET URL ORDER HISTORY PARAM
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  const orderHistoryPage = urlParams.get('orderhistory')

  // NAVGIATION
  if (doesNotContain(pageURL, exceptions)) {
    setTimeout(() => {
      // FIND ACCOUNT NAVIGATION
      const accountNavigation = document.getElementsByClassName('tn-area-nav__list')[0]

      // CREATE ORDER HISTORY LINK
      const orderHistoryLink = document.createElement('li')
      orderHistoryLink.classList.add('tn-area-nav__list-item')
      orderHistoryLink.innerHTML = (orderHistoryPage) ? 'Order History' : '<a href="/account/upcomingevents?orderhistory=true">Order History</a>'

      // APPEND ORDER HISTORY LINK TO ACCOUNT NAVIGATION
      accountNavigation.append(orderHistoryLink)
    }, 100)
  }

  // BUILDER
  if (doesNotContain(pageURL, exceptions)) {
    setTimeout(() => {
      // ACCOUNT PAGE MAIN BLOCK
      const accountPageMainBlock = document.getElementsByClassName('tn-page-layout__main-container')[0]

      // FIND ACCOUNT NAVIGATION
      const accountNavigation = document.getElementsByClassName('tn-area-nav__list')[0]

      // DISPLAY ORDER HISTORY PAGE
      if (orderHistoryPage) {
        // HIDE NO ORDERS BLOCK
        let noOrdersBlock = document.getElementsByClassName('tn-empty-cart-message')[0]
        if (noOrdersBlock) {
          noOrdersBlock.style.display = 'none'
        } else {
          document.getElementsByClassName('tn-upcoming-event__list')[0].style.display = 'none'
          // CREATE NO ORDERS BLOCK
          noOrdersBlock = document.createElement('div')
          noOrdersBlock.classList.add('tn-empty-cart-message')
          noOrdersBlock.style.display = 'none'
          accountPageMainBlock.append(noOrdersBlock)
        }

        // REPLACE PAGE TITLE
        document.title = 'Order History'

        /**
         * REPLACE UPCOMING EVENTS LINK
         */
        const upcomingEventsItem = [...accountNavigation.children].find(
          el => el.innerHTML.trim() === "Upcoming Events"
        );

        if (upcomingEventsItem) {
          upcomingEventsItem.innerHTML = '<a href="/account/upcomingevents">Upcoming Events</a>'
        }

        // PAGE HEADING
        document.getElementById('tn-page-heading').innerHTML = 'Order History'

        // PAGE LEAD COPY
        document.getElementsByClassName('tn-heading-sub-text')[0].innerHTML = 'Your order history is listed below by date.'

        // USE DATA LAYER
        const sessionData = window.dataLayer.find(function (e) { return e.hasOwnProperty('session') }).session
        const sessionKeyURL = sessionData.key
        const customerNumber = sessionData.customer.id

        loadOrders(noOrdersBlock, accountPageMainBlock, sessionKeyURL, customerNumber)
      }
    }, 100)
  }
}

// Adding Order history link to dropdown menu
const utilityNav = document.querySelector('ul.tn-utility-nav-account-menu__list');
if (utilityNav) {
  const li = document.createElement('li');
  li.innerHTML = '<a class="tn-utility-nav-account-menu__link" href="/account/upcomingevents?orderhistory=true">Order History</a>';
  utilityNav.insertBefore(li, utilityNav.lastElementChild);
}
